// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"438ac334","42":"607647cf","79":"7f6e2d73","109":"6e44000f","148":"d24557e5","238":"70fbd223","434":"ee820cd6","445":"d7ce595a","595":"899360ec","747":"4caadd2d","788":"c7a396bb","802":"d8ec758f","920":"445d0580"}[chunkId] + ".chunk.js";
};